import React from 'react';
import { Image, List, Icon } from 'semantic-ui-react';
import "../css/Footer.scss"

const Footer = () => {
    return (
        <div className="ui horizontal aligned">
            <div className="list item">
            <Icon name="copyright outline" />2022
            
            </div>
            <div className="list item">
            <h4 className="waw">WarszaWa</h4>
            </div>
            <div className="list item">
            Site by Denis Poplavskii
            </div>
            
            
            
        </div>
    )
}

export default Footer
